export const AUTH_ROUTE_PATHS = {
  signIn: '/sign-in',
  signUp: '/sign-up',
  authCallback: '/auth/callback',
  resetPassword: '/reset-password',
  resetPasswordConfirm: '/reset-password/:token',
  verifyEmail: '/verify-email/:token',
} as const;
